import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfPen,
  PdfColor,
  PdfFont,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';
import '../../pdf/draw/label';

export class Telefon__Base implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 12;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const size = { width: PdfUnit.FromMillimeters(71.63), height: PdfUnit.FromMillimeters(147.57) };
    const margin = PdfUnit.FromMillimeters(5);

    const origin = new PdfPoint(
      (PdfSize.A4.width - size.width) / 2,
      (PdfSize.A4.height - size.height) / 2
    );
    const rect = new PdfRect(origin.x, origin.y, size.width, size.height);

    const round = PdfUnit.FromMillimeters(12.5);
    const background = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.1));
    const page = pdf.addPage();

    page.drawRoundedRectangle(null, background, rect, round);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 10), null, rect, round);

    const topSize = { width: PdfUnit.FromMillimeters(21), height: PdfUnit.FromMillimeters(6) };
    const topRect = new PdfRect(
      rect.centerX - topSize.width / 2,
      rect.y + PdfUnit.FromMillimeters(5),
      topSize.width,
      topSize.height
    );
    page.drawRoundedRectangle(null, PdfBrush.Black, topRect, PdfUnit.FromMillimeters(3));

    const timeFont = new PdfFont(PdfFont.FONT_NAME, 48);
    const timeRect = new PdfRect(
      rect.x + margin,
      rect.y + PdfUnit.FromMillimeters(20),
      rect.width - 2 * margin,
      PdfUnit.FromMillimeters(20)
    );
    page.drawString('9:41', timeFont, PdfBrush.Black, null, timeRect, ETextAlign.Center);

    const iconsRect = new PdfRect(
      rect.x + margin,
      rect.y + PdfUnit.FromMillimeters(45),
      rect.width - 2 * margin,
      PdfUnit.FromMillimeters(90)
    );

    const count = Math.min(opts.list.length, 12);
    const items = opts.list.slice(0, count);

    const labelTexts = items.map((t) => [t.label.getText() ?? '']);
    const textTexts = items.map((t) => [t.text]);

    const labelFont = page.adjustFontMulti(
      labelTexts,
      GUtil.baseFont,
      new PdfSize(iconsRect.width / 3, (iconsRect.height / 4) * 3)
    );
    const textFont = page.adjustFontMulti(
      textTexts,
      GUtil.baseFont,
      new PdfSize(iconsRect.width / 3, iconsRect.height / 4)
    );

    const icons = Array.from({ length: 12 }, (_, i) => ({ x: Math.floor(i / 4), y: i % 4 })).sort(
      () => opts.data.random.next(0, 2) * 2 - 1
    );

    for (let i = 0; i < count; i++) {
      const { x, y } = icons[i];
      const r = new PdfRect(
        iconsRect.x + (iconsRect.width / 3) * x,
        iconsRect.y + (iconsRect.height / 4) * y,
        iconsRect.width / 3,
        iconsRect.height / 4
      );
      const h = r.height / 4;

      const r1 = new PdfRect(r.x, r.y, r.width, r.height - h);
      const r2 = new PdfRect(r.x, r.y + r.height - h, r.width, h);

      page.drawLabel(items[i].label, { rect: r1, font: labelFont });
      page.drawString(items[i].text, textFont, PdfBrush.Black, null, r2, ETextAlign.Center);
    }
  }
}

export class Telefon__Tlacitkovy implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 8;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const bodyW = PdfUnit.FromMillimeters(60);
    const bodyH = PdfUnit.FromMillimeters(120);
    const round = PdfUnit.FromMillimeters(8);

    const origin = new PdfPoint((PdfSize.A4.width - bodyW) / 2, (PdfSize.A4.height - bodyH) / 2);
    const rect = new PdfRect(origin.x, origin.y, bodyW, bodyH);

    const background = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.1));
    const shadow = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.2));
    const screenBg = new PdfBrush(PdfColor.fromHex('#E8F5E9')); // Classic retro LCD green
    const page = pdf.addPage();

    // Subtle shadow for the body
    page.drawRoundedRectangle(
      null,
      shadow,
      new PdfRect(rect.x + 1, rect.y + 1, rect.width, rect.height),
      round
    );
    page.drawRoundedRectangle(null, background, rect, round);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 1.5), null, rect, round);

    const earpieceW = PdfUnit.FromMillimeters(12);
    const earpieceH = PdfUnit.FromMillimeters(2);
    const earpieceRect = new PdfRect(
      rect.centerX - earpieceW / 2,
      rect.y + PdfUnit.FromMillimeters(6),
      earpieceW,
      earpieceH
    );
    page.drawRoundedRectangle(null, PdfBrush.Black, earpieceRect, earpieceH / 2);

    const screenMargin = PdfUnit.FromMillimeters(7);
    const screenTop = rect.y + PdfUnit.FromMillimeters(14);
    const screenH = PdfUnit.FromMillimeters(46);
    const screenRect = new PdfRect(
      rect.x + screenMargin,
      screenTop,
      rect.width - 2 * screenMargin,
      screenH
    );

    // Screen bezel
    page.drawRoundedRectangle(
      null,
      PdfBrush.Black,
      new PdfRect(screenRect.x - 1, screenRect.y - 1, screenRect.width + 2, screenRect.height + 2),
      PdfUnit.FromMillimeters(2)
    );
    page.drawRoundedRectangle(null, screenBg, screenRect, PdfUnit.FromMillimeters(1));

    const count = Math.min(opts.list.length, this.countMax());
    const items = opts.list.slice(0, count);

    const rowH = screenH / count;
    const labelTexts = items.map((t) => [t.label.getText() ?? '']);
    const textTexts = items.map((t) => [t.text]);

    const labelFont = page.adjustFontMulti(
      labelTexts,
      GUtil.baseFont,
      new PdfSize(screenRect.width * 0.5, rowH * 0.8)
    );
    const textFont = page.adjustFontMulti(
      textTexts,
      GUtil.baseFont,
      new PdfSize(screenRect.width * 0.4, rowH * 0.8)
    );

    for (let i = 0; i < count; i++) {
      const rowY = screenRect.y + i * rowH;
      const rowRect = new PdfRect(screenRect.x + 1, rowY, screenRect.width - 2, rowH);

      const labelRect = new PdfRect(
        rowRect.x + 1,
        rowRect.y + rowRect.height * 0.1,
        rowRect.width * 0.5,
        rowRect.height * 0.8
      );
      const textRect = new PdfRect(
        rowRect.x + rowRect.width * 0.55,
        rowRect.y + rowRect.height * 0.1,
        rowRect.width * 0.4,
        rowRect.height * 0.8
      );

      page.drawLabel(items[i].label, { rect: labelRect, font: labelFont });
      page.drawString(
        items[i].text,
        textFont,
        PdfBrush.Black,
        null,
        textRect,
        ETextAlign.CenterRight
      );

      if (i < count - 1) {
        page.drawLine(
          new PdfPen(PdfColor.fromCmyk(0, 0, 0, 0.2), 0.2),
          new PdfPoint(screenRect.x + 2, rowRect.bottom),
          new PdfPoint(screenRect.right - 2, rowRect.bottom)
        );
      }
    }

    const controlTop = screenRect.bottom + PdfUnit.FromMillimeters(5);
    const dpadSize = PdfUnit.FromMillimeters(16);
    const dpadRect = new PdfRect(rect.centerX - dpadSize / 2, controlTop, dpadSize, dpadSize);

    // D-Pad and soft keys
    page.drawEllipse(
      new PdfPen(PdfColor.fromRgb(0, 0, 0), 1),
      new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.2)),
      dpadRect
    );
    const centerBtnR = dpadSize * 0.3;
    page.drawEllipse(
      new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5),
      PdfBrush.White,
      new PdfRect(
        dpadRect.centerX - centerBtnR,
        dpadRect.centerY - centerBtnR,
        centerBtnR * 2,
        centerBtnR * 2
      )
    );

    const softKeyW = PdfUnit.FromMillimeters(12);
    const softKeyH = PdfUnit.FromMillimeters(5);
    const softKeyY = controlTop + PdfUnit.FromMillimeters(2);
    page.drawRoundedRectangle(
      GUtil.basePen,
      null,
      new PdfRect(rect.x + screenMargin, softKeyY, softKeyW, softKeyH),
      1.5
    );
    page.drawRoundedRectangle(
      GUtil.basePen,
      null,
      new PdfRect(rect.right - screenMargin - softKeyW, softKeyY, softKeyW, softKeyH),
      1.5
    );

    const callY = controlTop + PdfUnit.FromMillimeters(9);
    page.drawRoundedRectangle(
      GUtil.basePen,
      new PdfBrush(PdfColor.fromHex('#4CAF50')),
      new PdfRect(rect.x + screenMargin, callY, softKeyW, softKeyH),
      1.5
    );
    page.drawRoundedRectangle(
      GUtil.basePen,
      new PdfBrush(PdfColor.fromHex('#F44336')),
      new PdfRect(rect.right - screenMargin - softKeyW, callY, softKeyW, softKeyH),
      1.5
    );

    const keyGap = PdfUnit.FromMillimeters(2);
    const keyW = (rect.width - 2 * screenMargin - 2 * keyGap) / 3;
    const keyH = PdfUnit.FromMillimeters(8);
    const keypadTop = controlTop + dpadSize + PdfUnit.FromMillimeters(4);

    const keyLabels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
    const keyFont = new PdfFont(PdfFont.FONT_NAME, 14);

    for (let i = 0; i < 12; i++) {
      const col = i % 3;
      const row = Math.floor(i / 3);
      const kx = rect.x + screenMargin + col * (keyW + keyGap);
      const ky = keypadTop + row * (keyH + keyGap);
      const keyRect = new PdfRect(kx, ky, keyW, keyH);
      page.drawRoundedRectangle(
        new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5),
        new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.05)),
        keyRect,
        2
      );
      page.drawString(keyLabels[i], keyFont, PdfBrush.Black, null, keyRect, ETextAlign.Center);
    }

    const micY = rect.bottom - PdfUnit.FromMillimeters(4);
    page.drawEllipse(null, PdfBrush.Black, new PdfRect(rect.centerX - 0.5, micY - 0.5, 1, 1));
  }
}

export class Telefon__Tablet implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 12;
  }
  countMin(): number {
    return 4;
  }
  countMax(): number {
    return 16;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const bodyW = PdfUnit.FromMillimeters(160);
    const bodyH = PdfUnit.FromMillimeters(115);
    const margin = PdfUnit.FromMillimeters(5);
    const bezel = PdfUnit.FromMillimeters(4);
    const round = PdfUnit.FromMillimeters(8);

    const origin = new PdfPoint((PdfSize.A4.width - bodyW) / 2, (PdfSize.A4.height - bodyH) / 2);
    const rect = new PdfRect(origin.x, origin.y, bodyW, bodyH);

    const background = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.08));
    const shadow = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.15));
    const screenBg = new PdfBrush(PdfColor.fromHex('#F5F5F7'));
    const dockBg = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.08));
    const page = pdf.addPage();

    // Tablet body with shadow
    page.drawRoundedRectangle(
      null,
      shadow,
      new PdfRect(rect.x + 1, rect.y + 1, rect.width, rect.height),
      round
    );
    page.drawRoundedRectangle(null, background, rect, round);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 2), null, rect, round);

    const screenRect = new PdfRect(
      rect.x + bezel,
      rect.y + bezel,
      rect.width - 2 * bezel,
      rect.height - 2 * bezel
    );
    page.drawRoundedRectangle(
      null,
      PdfBrush.Black,
      new PdfRect(
        screenRect.x - 0.5,
        screenRect.y - 0.5,
        screenRect.width + 1,
        screenRect.height + 1
      ),
      4.5
    );
    page.drawRoundedRectangle(null, screenBg, screenRect, 4);

    const cameraR = PdfUnit.FromMillimeters(1.5);
    page.drawEllipse(
      null,
      PdfBrush.Black,
      new PdfRect(rect.centerX - cameraR, rect.y + bezel / 2 - cameraR, cameraR * 2, cameraR * 2)
    );

    const statusBarH = PdfUnit.FromMillimeters(6);
    const statusBarRect = new PdfRect(screenRect.x, screenRect.y, screenRect.width, statusBarH);

    const timeFont = new PdfFont(PdfFont.FONT_NAME, 16);
    const timeRect = new PdfRect(
      statusBarRect.x + PdfUnit.FromMillimeters(5),
      statusBarRect.y,
      PdfUnit.FromMillimeters(20),
      statusBarH
    );
    page.drawString('9:41', timeFont, PdfBrush.Black, null, timeRect, ETextAlign.CenterLeft);

    const batteryW = PdfUnit.FromMillimeters(8);
    const batteryH = PdfUnit.FromMillimeters(3.5);
    const batteryRect = new PdfRect(
      statusBarRect.right - batteryW - PdfUnit.FromMillimeters(5),
      statusBarRect.y + (statusBarH - batteryH) / 2,
      batteryW,
      batteryH
    );
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5), null, batteryRect, 0.5);
    const batteryFill = new PdfRect(
      batteryRect.x + 0.5,
      batteryRect.y + 0.5,
      (batteryW - 1) * 0.8,
      batteryH - 1
    );
    page.drawRectangle(null, PdfBrush.Black, batteryFill);

    const dockH = PdfUnit.FromMillimeters(16);
    const dockMargin = PdfUnit.FromMillimeters(10);
    const dockRect = new PdfRect(
      screenRect.x + dockMargin,
      screenRect.bottom - dockH - PdfUnit.FromMillimeters(4),
      screenRect.width - 2 * dockMargin,
      dockH
    );
    page.drawRoundedRectangle(null, dockBg, dockRect, 6);

    const appAreaRect = new PdfRect(
      screenRect.x + margin,
      statusBarRect.bottom + margin,
      screenRect.width - 2 * margin,
      screenRect.height - statusBarH - dockH - 3 * margin
    );

    const cols = 4;
    const rows = 4;
    const cellW = appAreaRect.width / cols;
    const cellH = appAreaRect.height / rows;

    const count = Math.min(opts.list.length, this.countMax());
    const items = opts.list.slice(0, count);

    const positions = Array.from({ length: cols * rows }, (_, i) => ({
      x: i % cols,
      y: Math.floor(i / cols),
    })).sort(() => opts.data.random.next(0, 2) * 2 - 1);

    const labelTexts = items.map((t) => [t.label.getText() ?? '']);
    const textTexts = items.map((t) => [t.text]);

    const labelFont = page.adjustFontMulti(
      labelTexts,
      GUtil.baseFont,
      new PdfSize(cellW * 0.6, cellH * 0.5)
    );
    const textFont = page.adjustFontMulti(
      textTexts,
      GUtil.baseFont,
      new PdfSize(cellW * 0.9, cellH * 0.2)
    );

    const pastelColors = [
      '#FFB7B2',
      '#FFDAC1',
      '#E2F0CB',
      '#B5EAD7',
      '#C7CEEA',
      '#FF9AA2',
      '#FFB7B2',
      '#FFDAC1',
      '#E2F0CB',
      '#B5EAD7',
      '#C7CEEA',
      '#97C1A9',
      '#A0E7E5',
      '#B4F8C8',
      '#FBE7C6',
      '#FFAEBC',
    ];

    for (let i = 0; i < count; i++) {
      const { x, y } = positions[i];
      const cx = appAreaRect.x + x * cellW;
      const cy = appAreaRect.y + y * cellH;

      const iconSize = Math.min(cellW, cellH) * 0.6;
      const iconRect = new PdfRect(
        cx + (cellW - iconSize) / 2,
        cy + (cellH * 0.8 - iconSize) / 2,
        iconSize,
        iconSize
      );
      const textRect = new PdfRect(cx, cy + cellH * 0.75, cellW, cellH * 0.2);

      const iconBg = new PdfBrush(PdfColor.fromHex(pastelColors[i % pastelColors.length]));
      page.drawRoundedRectangle(null, iconBg, iconRect, iconSize * 0.2);

      page.drawLabel(items[i].label, { rect: iconRect, font: labelFont });
      page.drawString(items[i].text, textFont, PdfBrush.Black, null, textRect, ETextAlign.Center);
    }

    const homeBarW = PdfUnit.FromMillimeters(30);
    const homeBarH = PdfUnit.FromMillimeters(1.5);
    const homeBarRect = new PdfRect(
      screenRect.centerX - homeBarW / 2,
      screenRect.bottom - PdfUnit.FromMillimeters(2.5),
      homeBarW,
      homeBarH
    );
    page.drawRoundedRectangle(
      null,
      new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.4)),
      homeBarRect,
      0.75
    );
  }
}

export class Telefon__Retro implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 6;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 8;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const bodyW = PdfUnit.FromMillimeters(60);
    const bodyH = PdfUnit.FromMillimeters(120);
    const round = PdfUnit.FromMillimeters(8);

    const origin = new PdfPoint((PdfSize.A4.width - bodyW) / 2, (PdfSize.A4.height - bodyH) / 2);
    const rect = new PdfRect(origin.x, origin.y, bodyW, bodyH);

    const background = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.1));
    const shadow = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.15));
    const screenBg = new PdfBrush(PdfColor.fromHex('#F0F4C3')); // Slight yellowish retro LCD
    const page = pdf.addPage();

    // Antenna (drawn first so it's behind)
    const antennaW = PdfUnit.FromMillimeters(4);
    const antennaH = PdfUnit.FromMillimeters(15);
    const antennaX = rect.right - PdfUnit.FromMillimeters(12);
    const antennaRect = new PdfRect(
      antennaX,
      rect.y - antennaH + PdfUnit.FromMillimeters(2),
      antennaW,
      antennaH
    );
    page.drawRoundedRectangle(null, new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.2)), antennaRect, 1);
    page.drawRoundedRectangle(
      null,
      PdfBrush.Black,
      new PdfRect(antennaX - 0.5, rect.y - antennaH - 1, antennaW + 1, 3),
      1
    );

    // Body with shadow
    page.drawRoundedRectangle(
      null,
      shadow,
      new PdfRect(rect.x + 1, rect.y + 1, rect.width, rect.height),
      round
    );
    page.drawRoundedRectangle(null, background, rect, round);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 1.5), null, rect, round);

    const hingeY = rect.y + PdfUnit.FromMillimeters(55);
    page.drawLine(
      new PdfPen(PdfColor.fromRgb(0, 0, 0), 3),
      new PdfPoint(rect.x + 2, hingeY),
      new PdfPoint(rect.right - 2, hingeY)
    );

    // Screen area (top half)
    const screenMargin = PdfUnit.FromMillimeters(8);
    const screenRect = new PdfRect(
      rect.x + screenMargin,
      rect.y + PdfUnit.FromMillimeters(10),
      rect.width - 2 * screenMargin,
      PdfUnit.FromMillimeters(40)
    );
    page.drawRoundedRectangle(
      null,
      PdfBrush.Black,
      new PdfRect(screenRect.x - 1, screenRect.y - 1, screenRect.width + 2, screenRect.height + 2),
      2
    );
    page.drawRoundedRectangle(null, screenBg, screenRect, 1);

    // Earpiece holes
    const speakerY = rect.y + PdfUnit.FromMillimeters(4);
    for (let i = 0; i < 3; i++) {
      page.drawEllipse(
        null,
        PdfBrush.Black,
        new PdfRect(rect.centerX - 3 + i * 3 - 0.5, speakerY - 0.5, 1, 1)
      );
    }

    const count = Math.min(opts.list.length, this.countMax());
    const items = opts.list.slice(0, count);
    const rowH = screenRect.height / count;

    const labelTexts = items.map((t) => [t.label.getText() ?? '']);
    const textTexts = items.map((t) => [t.text]);

    const labelFont = page.adjustFontMulti(
      labelTexts,
      GUtil.baseFont,
      new PdfSize(screenRect.width * 0.4, rowH * 0.7)
    );
    const textFont = page.adjustFontMulti(
      textTexts,
      GUtil.baseFont,
      new PdfSize(screenRect.width * 0.5, rowH * 0.7)
    );

    for (let i = 0; i < count; i++) {
      const rowY = screenRect.y + i * rowH;
      const rowRect = new PdfRect(screenRect.x + 1, rowY, screenRect.width - 2, rowH);

      const labelRect = new PdfRect(
        rowRect.x + 1,
        rowRect.y + rowRect.height * 0.15,
        rowRect.width * 0.4,
        rowRect.height * 0.7
      );
      const textRect = new PdfRect(
        rowRect.x + rowRect.width * 0.45,
        rowRect.y + rowRect.height * 0.15,
        rowRect.width * 0.5,
        rowRect.height * 0.7
      );

      page.drawLabel(items[i].label, { rect: labelRect, font: labelFont });
      page.drawString(
        items[i].text,
        textFont,
        PdfBrush.Black,
        null,
        textRect,
        ETextAlign.CenterLeft
      );

      if (i < count - 1) {
        page.drawLine(
          new PdfPen(PdfColor.fromCmyk(0, 0, 0, 0.2), 0.2),
          new PdfPoint(screenRect.x + 2, rowRect.bottom),
          new PdfPoint(screenRect.right - 2, rowRect.bottom)
        );
      }
    }

    // Controls (bottom half)
    const controlTop = hingeY + PdfUnit.FromMillimeters(6);
    const dpadSize = PdfUnit.FromMillimeters(14);
    const dpadRect = new PdfRect(rect.centerX - dpadSize / 2, controlTop, dpadSize, dpadSize);
    page.drawEllipse(GUtil.basePen, new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.2)), dpadRect);
    page.drawEllipse(
      GUtil.basePen,
      PdfBrush.White,
      new PdfRect(dpadRect.centerX - 2, dpadRect.centerY - 2, 4, 4)
    );

    const btnW = PdfUnit.FromMillimeters(10);
    const btnH = PdfUnit.FromMillimeters(6);
    page.drawRoundedRectangle(
      GUtil.basePen,
      new PdfBrush(PdfColor.fromHex('#4CAF50')),
      new PdfRect(rect.x + screenMargin, controlTop + 2, btnW, btnH),
      1.5
    );
    page.drawRoundedRectangle(
      GUtil.basePen,
      new PdfBrush(PdfColor.fromHex('#F44336')),
      new PdfRect(rect.right - screenMargin - btnW, controlTop + 2, btnW, btnH),
      1.5
    );

    // Keypad
    const keypadTop = controlTop + dpadSize + PdfUnit.FromMillimeters(4);
    const keyGap = PdfUnit.FromMillimeters(2.5);
    const keyW = (rect.width - 2 * screenMargin - 2 * keyGap) / 3;
    const keyH = (rect.bottom - keypadTop - PdfUnit.FromMillimeters(8) - 3 * keyGap) / 4;

    const keyLabels = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
    const keyFont = new PdfFont(PdfFont.FONT_NAME, 12);

    for (let i = 0; i < 12; i++) {
      const col = i % 3;
      const row = Math.floor(i / 3);
      const kx = rect.x + screenMargin + col * (keyW + keyGap);
      const ky = keypadTop + row * (keyH + keyGap);
      const keyRect = new PdfRect(kx, ky, keyW, keyH);
      page.drawRoundedRectangle(
        GUtil.basePen,
        new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.05)),
        keyRect,
        2
      );
      page.drawString(keyLabels[i], keyFont, PdfBrush.Black, null, keyRect, ETextAlign.Center);
    }

    const micY = rect.bottom - PdfUnit.FromMillimeters(4);
    const micR = PdfUnit.FromMillimeters(1);
    page.drawEllipse(
      GUtil.basePen,
      null,
      new PdfRect(rect.centerX - micR, micY - micR, micR * 2, micR * 2)
    );
  }
}

export class Telefon__Otocivy implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 6;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const bodyW = PdfUnit.FromMillimeters(80);
    const bodyH = PdfUnit.FromMillimeters(90);

    const origin = new PdfPoint((PdfSize.A4.width - bodyW) / 2, (PdfSize.A4.height - bodyH) / 2);
    const rect = new PdfRect(origin.x, origin.y, bodyW, bodyH);

    const background = new PdfBrush(PdfColor.fromHex('#424242')); // Dark grey bakelite look
    const darkBg = new PdfBrush(PdfColor.fromHex('#212121'));
    const shadow = new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.2));
    const page = pdf.addPage();

    // Body shadow
    page.drawRoundedRectangle(
      null,
      shadow,
      new PdfRect(rect.x + 2, rect.y + 2, rect.width, rect.height),
      10
    );
    // Body base
    page.drawRoundedRectangle(null, background, rect, 10);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 1), null, rect, 10);

    // Handset cradle
    const cradleW = bodyW * 0.7;
    const cradleH = PdfUnit.FromMillimeters(10);
    const cradleRect = new PdfRect(rect.centerX - cradleW / 2, rect.y + 4, cradleW, cradleH);
    page.drawRoundedRectangle(null, darkBg, cradleRect, 5);

    // Handset
    const handsetW = bodyW * 0.9;
    const handsetH = PdfUnit.FromMillimeters(16);
    const handsetY = rect.y - PdfUnit.FromMillimeters(4);
    const handsetRect = new PdfRect(rect.centerX - handsetW / 2, handsetY, handsetW, handsetH);
    page.drawRoundedRectangle(
      null,
      shadow,
      new PdfRect(handsetRect.x + 1, handsetRect.y + 1, handsetRect.width, handsetRect.height),
      8
    );
    page.drawRoundedRectangle(null, background, handsetRect, 8);
    page.drawRoundedRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 1.5), null, handsetRect, 8);

    // Ear and mouth pieces
    const sideW = handsetW * 0.2;
    page.drawEllipse(
      null,
      darkBg,
      new PdfRect(handsetRect.x + 2, handsetRect.y + 2, sideW, handsetH - 4)
    );
    page.drawEllipse(
      null,
      darkBg,
      new PdfRect(handsetRect.right - sideW - 2, handsetRect.y + 2, sideW, handsetH - 4)
    );

    // Cord
    const cordStartX = handsetRect.x + sideW / 2;
    const cordStartY = handsetRect.bottom;
    const cordEndX = rect.x + 8;
    const cordEndY = rect.y + bodyH * 0.4;
    const cordPoints: PdfPoint[] = [];
    const segments = 20;
    for (let i = 0; i <= segments; i++) {
      const t = i / segments;
      const x = cordStartX + (cordEndX - cordStartX) * t;
      const y = cordStartY + (cordEndY - cordStartY) * t;
      const wave = Math.sin(t * Math.PI * 6) * 4 * (1 - t);
      cordPoints.push(new PdfPoint(x + wave, y));
    }
    page.drawLines(new PdfPen(PdfColor.fromRgb(0, 0, 0), 2.5), cordPoints);

    // Label area (classic paper directory)
    const labelAreaW = bodyW * 0.8;
    const labelAreaH = PdfUnit.FromMillimeters(30);
    const labelAreaRect = new PdfRect(
      rect.centerX - labelAreaW / 2,
      rect.y + PdfUnit.FromMillimeters(18),
      labelAreaW,
      labelAreaH
    );
    page.drawRectangle(null, new PdfBrush(PdfColor.fromHex('#FAFAFA')), labelAreaRect);
    page.drawRectangle(new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5), null, labelAreaRect);

    const count = Math.min(opts.list.length, this.countMax());
    const items = opts.list.slice(0, count);
    const rowH = labelAreaH / count;

    const labelTexts = items.map((t) => [t.label.getText() ?? '']);
    const textTexts = items.map((t) => [t.text]);

    const labelFont = page.adjustFontMulti(
      labelTexts,
      GUtil.baseFont,
      new PdfSize(labelAreaW * 0.4, rowH * 0.7)
    );
    const textFont = page.adjustFontMulti(
      textTexts,
      GUtil.baseFont,
      new PdfSize(labelAreaW * 0.5, rowH * 0.7)
    );

    for (let i = 0; i < count; i++) {
      const rowY = labelAreaRect.y + i * rowH;
      const rowRect = new PdfRect(labelAreaRect.x, rowY, labelAreaW, rowH);

      page.drawLabel(items[i].label, {
        rect: new PdfRect(rowRect.x + 2, rowY + rowH * 0.15, labelAreaW * 0.4, rowH * 0.7),
        font: labelFont,
      });
      page.drawString(
        items[i].text,
        textFont,
        PdfBrush.Black,
        null,
        new PdfRect(
          rowRect.x + labelAreaW * 0.45,
          rowY + rowH * 0.15,
          labelAreaW * 0.5,
          rowH * 0.7
        ),
        ETextAlign.CenterLeft
      );

      if (i < count - 1) {
        page.drawLine(
          new PdfPen(PdfColor.fromCmyk(0, 0, 0, 0.2), 0.2),
          new PdfPoint(labelAreaRect.x, rowRect.bottom),
          new PdfPoint(labelAreaRect.right, rowRect.bottom)
        );
      }
    }

    // Rotary Dial
    const dialR = PdfUnit.FromMillimeters(20);
    const dialCX = rect.centerX;
    const dialCY = labelAreaRect.bottom + dialR + PdfUnit.FromMillimeters(2);

    // Outer ring
    page.drawEllipse(
      new PdfPen(PdfColor.fromRgb(0, 0, 0), 1),
      new PdfBrush(PdfColor.fromCmyk(0, 0, 0, 0.05)),
      new PdfRect(dialCX - dialR, dialCY - dialR, dialR * 2, dialR * 2)
    );

    const holeR = PdfUnit.FromMillimeters(3.5);
    const holeDist = dialR * 0.7;
    const dialNumbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    const dialFont = new PdfFont(PdfFont.FONT_NAME, 10);

    for (let i = 0; i < 10; i++) {
      const angle = Math.PI * 0.7 + (i / 9) * (Math.PI * 1.5);
      const hx = dialCX + Math.cos(angle) * holeDist;
      const hy = dialCY + Math.sin(angle) * holeDist;

      page.drawString(
        dialNumbers[i],
        dialFont,
        PdfBrush.Black,
        null,
        new PdfRect(hx - 3, hy - 3, 6, 6),
        ETextAlign.Center
      );
      page.drawEllipse(
        new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5),
        null,
        new PdfRect(hx - holeR, hy - holeR, holeR * 2, holeR * 2)
      );
    }

    // Center piece
    const centerR = dialR * 0.35;
    page.drawEllipse(
      new PdfPen(PdfColor.fromRgb(0, 0, 0), 1),
      background,
      new PdfRect(dialCX - centerR, dialCY - centerR, centerR * 2, centerR * 2)
    );

    // Finger stop
    const stopAngle = Math.PI * 0.55;
    const stopX = dialCX + Math.cos(stopAngle) * (dialR - 2);
    const stopY = dialCY + Math.sin(stopAngle) * (dialR - 2);
    page.drawEllipse(null, darkBg, new PdfRect(stopX - 1.5, stopY - 1.5, 3, 3));
  }
}
